// src/features/authentication/TokenMonitor.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { logOut } from './features/authentication/authSlice';

const TokenMonitor = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(state => state.auth.accessToken);

    useEffect(() => {
        const checkToken = () => {
            if (accessToken) { // Only check if there’s a token
                try {
                    const decoded = jwtDecode(accessToken);
                    const currentTime = Math.floor(Date.now() / 1000);
                    if (decoded.exp < currentTime) {
                        dispatch(logOut());
                        navigate('/login', { state: { message: 'Sessio on päivääntynyt' } });
                    }
                } catch (e) {
                    dispatch(logOut());
                    navigate('/login', { state: { message: 'Sessio on päivääntynyt' } });
                }
            }
        };

        // Don’t start checking until there’s a token
        if (accessToken) {
            const interval = setInterval(checkToken, 1000); // Check every second
            return () => clearInterval(interval);
        }
    }, [accessToken, dispatch, navigate]);

    return children;
};

export default TokenMonitor;